import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  statusLabels: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 1),
  },
  remainingStatusLabels: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  collapseExpandIcon: {
    verticalAlign: 'middle',
    fontWeight: 'bold',
    paddingLeft: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.25),
  },
}));

export default useStyles;
